import { render } from "./landlord_academy_rule.vue?vue&type=template&id=c56e6d02&scoped=true"
import script from "./landlord_academy_rule.vue?vue&type=script&lang=js"
export * from "./landlord_academy_rule.vue?vue&type=script&lang=js"

import "./landlord_academy_rule.vue?vue&type=style&index=0&id=c56e6d02&lang=scss&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/3b689470-9235-485d-ba5a-49630a920e29/workspace/wellcee-h5-p_H4zR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c56e6d02"]])

export default __exports__